import { render, staticRenderFns } from "./Contselect.vue?vue&type=template&id=2ab75cbd&scoped=true&"
import script from "./Contselect.vue?vue&type=script&lang=js&"
export * from "./Contselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab75cbd",
  null
  
)

export default component.exports